import React from 'react';
import * as _ from 'lodash';
import Grid from '@material-ui/core/Grid';
import { useQueryParams } from '../../../../hooks/atoms/query-params-hook';
import AppTable from '../../../basic/AppTable';

const TraitTextCorpusUploadPreview = (
  {
    dataCSV,
  },
) => {
  const paginationWithoutCount = useQueryParams();

  if (!dataCSV) {
    return <h5>No data to preview</h5>;
  }

  const { rows, columns } = dataCSV;

  const data = rows.map((r) => {
    return r.reduce((acc, attr) => {
      // acc[attr.Key] = _.isEmpty(attr.Value) ? null : attr.Value;
      if (!_.isEmpty(attr.Value)) {
        acc[attr.Key] = attr.Value;
      }
      return acc;
    }, {});
  });

  return (
    <Grid container item>
      <AppTable
        columns={ columns }
        data={ data?.slice(paginationWithoutCount.page * paginationWithoutCount.limit, (paginationWithoutCount.page + 1) * paginationWithoutCount.limit) }
        paginationProps={ { ...paginationWithoutCount, count: data?.length } }
      />
    </Grid>
  );
};

export default TraitTextCorpusUploadPreview;
